import AuthApi from '@apis/auth/AuthApi';
import userQueries from '@apis/queries/userQueries';
import { useFlow } from '@stackflow/react';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clearGtmUser } from '@utils/gtm';
import { useSetAtom } from 'jotai';
import { useCookies } from 'react-cookie';

function useLogout() {
    const setSidebarOpen = useSetAtom(isSidebarOpenAtom);
    const [cookies, __, removeCookie] = useCookies(['accessToken', 'refreshToken']);
    const { pop } = useFlow();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: AuthApi.signOut,
        onSettled() {
            clearGtmUser();
            setSidebarOpen(false);
            removeCookie('refreshToken', { path: '/' });
            removeCookie('accessToken', { path: '/' });
            pop(4);
            queryClient.resetQueries({ queryKey: userQueries.profile._def });
        },
    });
    return () => {
        const { refreshToken } = cookies;
        mutate(refreshToken);
    };
}

export default useLogout;
